export enum ChallengeManagementTabTypes {
  CREATE = 'CREATE',
  DETAILS = 'DETAILS',
  SCORECARD = 'SCORECARD',
  SETTINGS = 'SETTINGS',
  TYPE = 'TYPE'
}
